export const checkIsMobileDevice = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileUA = /android|iphone|ipad|ipod|windows phone/i.test(
    ua.toLowerCase()
  );

  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isNotDevTools = !navigator.webdriver;

  const isSmallScreen = window.innerWidth <= 768;

  return isMobileUA && isTouchDevice && isNotDevTools && isSmallScreen;
};

export const isDeviceIos = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

  return isIOS;
};
